import React, { useCallback } from 'react';
import ExtraCardBrandSelect from './ExtraCardBrandSelect';
import { CardBrands } from 'types/customers';
import ExtraPaymentTypeIdField from './ExtraPaymentTypeIdField';
import Button from 'components/Button/Button';
import style from './ExtraPaymentTypeField.module.scss';
import breadcrumbs from 'assets/img/breadcrumbs.svg';
import { IExtraPaymentType } from 'modules/CustomersAndRestaurants/Restaurants/EditRestaurant/editRestaurantState/editRestaurantContext';
import { Rule } from 'antd/lib/form';
import { useTranslation } from 'react-i18next';

interface IExtraPaymentTypeField {
	extraPaymentType: IExtraPaymentType;
	selectedCardBrands: CardBrands[];
	changeExtraPaymentType: (id: string, value: IExtraPaymentType) => void;
	deleteExtraPaymentType: (value: string) => void;
}

const ExtraPaymentTypeField: React.FC<IExtraPaymentTypeField> = ({
	extraPaymentType,
	selectedCardBrands,
	changeExtraPaymentType,
	deleteExtraPaymentType,
}) => {
	const { t } = useTranslation('error');

	const validationRules = useCallback(
		(isPaymentTypeId: boolean) =>
			[
				({ getFieldValue }) => ({
					validator(_, value) {
						const fieldKey = `${isPaymentTypeId ? 'extraCardBrand' : 'extraPaymentTypeId'}-${
							extraPaymentType.id
						}`;
						const errorKey = isPaymentTypeId ? 'enterPaymentTypeId' : 'selectCardBrand';

						if (getFieldValue(fieldKey) && !value) {
							return Promise.reject(new Error(t(errorKey)));
						}

						return Promise.resolve();
					},
				}),
			] as Rule[],
		[t, extraPaymentType.id],
	);

	const handleDeleteField = () => {
		deleteExtraPaymentType(extraPaymentType.id);
	};

	const handleChangeBrand = (value: CardBrands) => {
		changeExtraPaymentType(extraPaymentType.id, { ...extraPaymentType, brand: value });
	};

	const handleChangePaymentType = (value: string) => {
		changeExtraPaymentType(extraPaymentType.id, { ...extraPaymentType, paymentTypeId: value });
	};

	return (
		<div className={style.container}>
			<ExtraPaymentTypeIdField
				fieldId={extraPaymentType.id}
				changePaymentTypeId={handleChangePaymentType}
				validationRules={validationRules(true)}
			/>
			<ExtraCardBrandSelect
				extraPaymentType={extraPaymentType}
				selectedCardBrands={selectedCardBrands}
				changeCardBrand={handleChangeBrand}
				validationRules={validationRules(false)}
			/>
			<Button
				className={style.button}
				theme="clear"
				icon={
					<svg className={style.closeIcon} onClick={handleDeleteField}>
						<use xlinkHref={`${breadcrumbs}#crossMark`} />
					</svg>
				}
			/>
		</div>
	);
};

export default React.memo(ExtraPaymentTypeField);
